import { useState, useEffect } from 'react';
import { fmtMoney } from '../lib/fmt';
import { countMondaysInMonth } from '../lib/dateHelpers';

interface MonthMetaCardProps {
  ym: string;
  metaVenda: number;
  taxaPct: number;
  isCurrent: boolean;
  onSave: (ym: string, val: number | null) => void;
}

export function MonthMetaCard({ ym, metaVenda, taxaPct, isCurrent, onSave }: MonthMetaCardProps) {
  const [local, setLocal] = useState(metaVenda > 0 ? metaVenda.toFixed(0) : '');

  useEffect(() => {
    setLocal(metaVenda > 0 ? metaVenda.toFixed(0) : '');
  }, [metaVenda]);

  const liquido = metaVenda > 0 ? metaVenda * (1 - taxaPct) : 0;
  const nSem = countMondaysInMonth(ym);
  const capSem = liquido > 0 ? liquido / nSem : 0;
  const [year, month] = ym.split('-').map(Number);
  const label = new Date(year, month - 1, 1).toLocaleDateString('pt-BR', { month: 'short', year: '2-digit' });

  return (
    <div
      className={`shrink-0 w-40 p-3 rounded-xl border ${isCurrent ? 'glow' : ''}`}
      style={{
        background: isCurrent ? 'rgba(244,122,32,.06)' : 'rgba(22,35,59,.6)',
        borderColor: isCurrent ? '#F47A20' : '#22324F',
      }}
    >
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-xs font-bold text-mbc-soft capitalize">{label}</span>
        {isCurrent && <span className="text-[9px] text-mbc-orangel uppercase">atual</span>}
      </div>
      <label className="text-[9px] text-mbc-mute uppercase tracking-wider">Meta venda</label>
      <input
        type="number"
        step="100000"
        value={local}
        onChange={e => setLocal(e.target.value)}
        onBlur={() => onSave(ym, parseFloat(local) || null)}
        placeholder="R$ —"
        className="w-full bg-mbc-panel2 border border-mbc-line rounded px-2 py-1 text-xs text-white text-right mt-0.5 mb-1.5"
      />
      {metaVenda > 0 ? (
        <>
          <div className="text-[10px] text-emerald-300">Líq: {fmtMoney(liquido)}</div>
          <div className="text-[10px] text-mbc-mute">÷{nSem} sem = {fmtMoney(capSem)}/sem</div>
        </>
      ) : (
        <div className="text-[10px] text-mbc-mute">preencha a meta</div>
      )}
    </div>
  );
}
